export default __webpack_public_path__ + "static/media/PolyM-Zoo-keeper-2.76217542.jpg";